import { Component } from "react"

/* Components */
import { InnerLayout, Transaction, Cards } from "../../components"

/* Widgets */
import RoundStat from "./RoundStat"
import RoundPayment from "./RoundPayment"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import {
    CloseIcon, PlayerIcon, OperatorIcon, BalanceIcon, ChipIcon, BetsIcon, DebitIcon,
    CreditIcon, NetIcon, RefundIcon, PayIcon, WheelIcon, ArrowRightIcon, WarningIcon, EyeOffIcon,
} from "../../components/Icons"


/*
    Widget RoundPlayer — ONE PLAYER OF ONE ROUND, THE SAME CARD IN EVERY GAME

    Opened by a ref from the player list: open({ player }). Everything it draws comes from
    the round itself, and the refund and the payment of the player live behind their own modal.

    api      the module of the game — view and credit
    config   what the game of the round draws of its own, see RoundView
*/
class RoundPlayer extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            player: "",
            data: null,
            status: "loading",
        }
    }

    /* Open Action */
    open = ({ player }) => {

        /* Check Parameters */
        if (!player) {
            return
        }

        this.setState({ visible: true, player, data: null, status: "loading" }, () => this.load())
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action */
    load = (reload = false) => {

        /* Fields */
        const { api, uid, gameID, postfix } = this.props
        const { player } = this.state

        /* Check Parameters */
        if (!uid || !gameID || !player) {
            this.setState({ status: "error", data: null })
            return
        }

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        api.view({ uid, gameID, player, postfix }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null })
            }
            else {
                this.setState({ status: "error", data: null })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null })
        })
    }

    /* Get The Cards Of One Row */
    getCards = (type, box = null) => {

        /* Fields */
        const { data } = this.state
        const list = []

        /* Check Cards */
        if (data && data.cards && Array.isArray(data.cards) && data.cards.length > 0) {
            data.cards.forEach((card) => {
                if (box !== null) {
                    if (card.type === type && parseInt(card.box) === parseInt(box)) {
                        list.push(card)
                    }
                }
                else if (card.type === type) {
                    list.push(card)
                }
            })
        }

        return list
    }

    /* THE NET OF THE PLAYER IN THE ROUND — WHAT WENT IN MINUS WHAT CAME BACK */
    getNet = () => {

        /* Fields */
        const { data } = this.state

        /* Fields */
        const debit = parseFloat(data.game.debit) > 0 ? parseFloat(data.game.debit) : 0
        const credit = parseFloat(data.game.credit) > 0 ? parseFloat(data.game.credit) : 0

        return debit - credit
    }

    /* Open The Payment Modal */
    payment = (type) => {

        /* Fields */
        const { data } = this.state

        /* Check Modal */
        if (!this._payment || !data) {
            return
        }

        this._payment.open({ type, game: data.game })
    }

    /* Draw The Bets Of The Player — every stake of the round next to what it paid back */
    _bets = () => {

        /* Fields */
        const { config } = this.props
        const { data } = this.state

        /* Fields */
        const names = config && config.betNames ? config.betNames : {}
        const list = data.processes && Array.isArray(data.processes) ? data.processes : []

        /* Check Bets */
        if (list.length === 0) {
            return null
        }

        return (
            <div className="rnd--bets">

                <div className="rnd--bets-head">
                    <BetsIcon size={13} />
                    {t("round.bets")}
                    <span className="rnd--bets-count">{list.length}</span>
                </div>

                <div className="rnd--bets-list">
                    {list.map((item, index) =>
                        <div className="rnd--bet" key={`${index}`}>

                            <div className={`rnd--bet-name ${item.type}`}>
                                {names[item.type] ? names[item.type] : `${item.type}`.toUpperCase()}
                                {item.box ? <b>BOX {item.box}</b> : null}
                            </div>

                            <div className="rnd--bet-total">{utils.convertor(item.total, data.game.symbol, data.game.isAfter)}</div>

                            <div className={`rnd--bet-win ${parseFloat(item.win) > 0 ? "" : "lose"}`}>
                                {parseFloat(item.win) > 0 ? `+ ${utils.convertor(item.win, data.game.symbol, data.game.isAfter)}` : t("widget.noWin")}
                            </div>

                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* THE MONEY ONE ROULETTE STAKE PAID BACK */
    getWin = (cellId) => {

        /* Fields */
        const { data } = this.state

        /* Check Result */
        if (!data.game.result) {
            return null
        }

        try {

            /* Fields */
            const results = JSON.parse(data.game.result)

            /* Check Results */
            if (!Array.isArray(results)) {
                return null
            }

            /* Fields */
            const found = results.find((item) => item.cellId === cellId)

            return found ? found.winAmount : null
        }
        catch {
            return null
        }
    }

    /* Draw The Stakes Of The Player — the roulette keeps them all in one column */
    _stakes = () => {

        /* Fields */
        const { data } = this.state

        /* Fields */
        let list = []

        try {
            const parsed = data.game.stakes ? JSON.parse(data.game.stakes) : []
            list = Array.isArray(parsed) ? parsed : []
        }
        catch {
            list = []
        }

        /* Check Stakes */
        if (list.length === 0) {
            return null
        }

        return (
            <div className="rnd--bets">

                <div className="rnd--bets-head">
                    <ChipIcon size={13} />
                    {t("round.bets")}
                    <span className="rnd--bets-count">{list.length}</span>
                </div>

                <div className="rnd--stakes">
                    {list.map((item, index) => {

                        /* Fields */
                        const win = this.getWin(item.cellId)

                        return (
                            <div className={`rnd--stake ${parseFloat(win) > 0 ? "win" : ""}`} key={`${index}`}>

                                <div className="rnd--stake-cell">{item.cellId}</div>

                                <div className="rnd--stake-value">{utils.convertor(item.value, data.game.symbol, data.game.isAfter)}</div>

                                <div className={`rnd--stake-win ${parseFloat(win) > 0 ? "" : "lose"}`}>
                                    {parseFloat(win) > 0 ? `+ ${utils.convertor(win, data.game.symbol, data.game.isAfter)}` : t("widget.noWin")}
                                </div>

                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    /* Draw The Cards Of The Player */
    _cards = () => {

        /* Fields */
        const { config, cardsHidden } = this.props

        /* Fields */
        const rows = config && Array.isArray(config.playerCards) ? config.playerCards : []

        /* Check Rows */
        if (rows.length === 0) {
            return null
        }

        /* THE HAND OF A LIVE ROUND STAYS CLOSED — the cards come with the end of the round or with its pause */
        if (cardsHidden) {
            return <div className="rnd--cards-hidden"><EyeOffIcon size={16} />{t("round.cardsHidden")}</div>
        }

        /* The rows a game only deals in a part of its rounds — a box the player never sat at among them */
        const list = rows.filter((row) => {

            /* Check Row */
            if (!row.optional) {
                return true
            }

            return this.getCards(row.type, row.box === undefined ? null : row.box).length > 0
        })

        /* Check List */
        if (list.length === 0) {
            return null
        }

        return (
            <div className={`cards--container ${config.playerCardsClass ? config.playerCardsClass : ""}`}>
                {list.map((row, index) =>
                    <Cards key={`${index}`} title={row.title()} cards={this.getCards(row.type, row.box === undefined ? null : row.box)} />
                )}
            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { config } = this.props
        const { data, status } = this.state

        /* Layout */
        if (status !== "ok" || !data || !data.game) {
            return <InnerLayout status={status === "ok" ? "error" : status} reload={() => this.load(true)} />
        }

        /* Fields */
        const game = data.game
        const net = this.getNet()
        const before = `${utils.checkValue(game.balanceBefore)}`.trim()
        const after = `${utils.checkValue(game.balanceAfter)}`.trim()

        return (
            <>
                {/* WHO THE PLAYER IS */}
                <div className="rnd--who">

                    <div className="rnd--who-avatar"><PlayerIcon size={18} /></div>

                    <div className="rnd--who-text">
                        <h3>{`${utils.checkValue(game.firstName)}`.trim() === "" ? game.player : game.firstName}</h3>
                        <p>{game.player}</p>
                    </div>

                    <div className="rnd--who-marks">

                        <div className="rnd--player-mark">
                            <OperatorIcon size={11} />
                            {`${utils.checkValue(game.operator)}`.trim() === "" ? "—" : game.operator}
                        </div>

                        {game.endReason
                            ? <div className="rnd--player-mark amber"><WarningIcon size={11} />{game.endReason}</div>
                            : null
                        }

                    </div>

                </div>

                {/* WHAT THE ROUND DID TO THE WALLET */}
                <div className="rnd--grid two">

                    <div className="rnd--card">

                        <div className="rnd--card-head"><ChipIcon size={13} />{t("round.money")}</div>

                        <div className="rnd--rows">

                            <RoundStat icon={<DebitIcon size={14} />} tone="green" title="DEBIT">
                                {utils.convertor(game.debit, game.symbol, game.isAfter)}
                            </RoundStat>

                            <RoundStat icon={<CreditIcon size={14} />} tone="red" title="CREDIT">
                                {utils.convertor(game.credit, game.symbol, game.isAfter)}
                            </RoundStat>

                            <RoundStat icon={<NetIcon size={14} />} tone="blue" title={t("widget.total")}>
                                <span className={net >= 0 ? "green" : "red"}>
                                    {net >= 0 ? "+ " : "- "}{utils.convertor(Math.abs(net), game.symbol, game.isAfter)}
                                </span>
                            </RoundStat>

                            <RoundStat icon={<ChipIcon size={14} />} tone="violet" title={t("round.betsTotal")}>
                                {utils.convertor(game.total, game.symbol, game.isAfter)}
                            </RoundStat>

                        </div>

                    </div>

                    <div className="rnd--card">

                        <div className="rnd--card-head"><BalanceIcon size={13} />{t("round.wallet")}</div>

                        <div className="rnd--rows">

                            <RoundStat icon={<BalanceIcon size={14} />} title={t("widget.balance")}>
                                {utils.convertor(game.startBalance, game.symbol, game.isAfter)}
                            </RoundStat>

                            {/* The wallet around the round, as the operator recorded it */}
                            <RoundStat icon={<ArrowRightIcon size={14} />} tone="blue" title={t("round.balance")}>
                                {before === "" && after === ""
                                    ? <span className="rnd--empty" title={t("round.balanceEmpty")}>—</span>
                                    : `${before === "" ? "—" : utils.convertor(game.balanceBefore, game.symbol, game.isAfter)} → ${after === "" ? "—" : utils.convertor(game.balanceAfter, game.symbol, game.isAfter)}`
                                }
                            </RoundStat>

                            <RoundStat icon={<RefundIcon size={14} />} tone="violet" title={t("widget.refunded")}>
                                {utils.convertor(game.refund, game.symbol, game.isAfter)}
                            </RoundStat>

                            <RoundStat icon={<PayIcon size={14} />} tone="amber" title={t("widget.paid")}>
                                {utils.convertor(game.paid, game.symbol, game.isAfter)}
                            </RoundStat>

                            {/* The Number The Round Landed On */}
                            {config && config.win === "roulette" && game.win
                                ? <RoundStat icon={<WheelIcon size={14} />} title={t("widget.winNumber")}>
                                    <div className={`rnd--wheel ${game.color ? game.color : "nospin"}`}>{game.win}</div>
                                </RoundStat>
                                : null
                            }

                        </div>

                    </div>

                </div>

                {/* THE BETS OF THE PLAYER */}
                {config && config.bets === "stakes" ? this._stakes() : this._bets()}

                {/* THE TRANSACTIONS OF THE PLAYER */}
                <Transaction symbol={game.symbol} data={data.transactions} />

                {/* THE CARDS OF THE PLAYER */}
                {this._cards()}
            </>
        )
    }

    render = () => {

        /* Fields */
        const { api, uid, socket, postfix } = this.props
        const { visible, status, data } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="rnd--modal wide"
                overlayClassName="rnd--overlay"
                closeTimeoutMS={200}
            >

                <div className="rnd--modal-header">

                    <div className="rnd--modal-icon blue"><PlayerIcon size={18} /></div>

                    <div className="rnd--modal-text">
                        <h2>{t("widget.playerInfo")}</h2>
                        <p>{t("round.playerSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="rnd--modal-close"><CloseIcon size={16} /></div>

                </div>

                <div className="rnd--modal-body">
                    {this._content()}
                </div>

                {/* THE MONEY OF THE PLAYER IS MOVED BY HAND */}
                {status === "ok" && data && data.game &&
                    <div className="rnd--modal-footer">
                        <div onClick={() => this.payment("refund")} className="rnd--button violet"><RefundIcon size={13} />{t("widget.refundTitle")}</div>
                        <div onClick={() => this.payment("payment")} className="rnd--button pink"><PayIcon size={13} />{t("widget.payTitle")}</div>
                    </div>
                }

                {/* Draw Payment */}
                <RoundPayment ref={(ref) => this._payment = ref} api={api} uid={uid} postfix={postfix} socket={socket} apply={() => this.load()} />

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(RoundPlayer)
